<template>
  <div class="page" id="allPage">
    <div class="layout">
      <!-- <TheHeader></TheHeader> -->
      <el-row class="mobile-header" :gutter="0">
        <el-col :span="4">
          <span class="icon-button" @click="drawer = true"><i class="ri-menu-line"></i></span>
        </el-col>
        <el-col :span="16" class="mobile-title">
          <el-tabs v-model="mactiveName" @tab-click="handleMobileTabClick">
            <el-tab-pane label="对话" name="first" style="margin-right: 20px;"></el-tab-pane>
            <el-tab-pane label="历史记录" name="second"></el-tab-pane>
          </el-tabs>
        </el-col>
        <el-col :span="2" v-if="false">
          <span class="icon-button" @click="onOpenNewSession"><i class="ri-sticky-note-add-line"></i></span>
        </el-col>
        <el-col :span="2" v-if="false">
          <span class="icon-button" ><i class="ri-bard-line"></i></span>
        </el-col>
      </el-row>
      <el-drawer
          :size="'70%'"
          :visible.sync="drawer"
          :with-header="false"
          :direction="'ltr'">
        <ThePersonPage
            class="drawer-history"
            @changeFontOld="toggleFont"
        ></ThePersonPage>
      </el-drawer>
      <div class="main" v-if="mactiveName === 'first'">
        <div class="aside">
          <div v-if="LogoImgUrl" class="title">
            <img style="height: 100%;width: auto" :src="LogoImgUrl" />
          </div>

          <!-- <TheHot @click="onHotClick"></TheHot> -->
          <div v-else class="title">
            <img src="../assets/img/index/logo.png" alt="">
            <div>{{ title }}</div>
          </div>
          <TheSessionHistory
            :list="sessionHistory"
            @openNewSession="onOpenNewSession"
            @click="onHistoryClick"
            @clearClick="onClearClick"
            @delSessionItem="onDelSessionItem"
          ></TheSessionHistory>
          <div class="fengexian"></div>
          <TheTool></TheTool>

          <div class="user-center" style="display: none">
            <img src="../assets/img/index/user.png" alt="">
            个人中心
            <i class="ri-arrow-right-double-line"></i>
          </div>
        </div>
        <div
          class="chat"
          v-bind:style="{
            backgroundImage: 'url(' + chatBgUrl + ')',
          }"
        >
          <div class="chat-top" v-if="webEquipmentType">
            <el-dropdown @command="changeTheme" style="display: none">
              <span class="el-dropdown-link">
                主题<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="light">浅色</el-dropdown-item>
                <el-dropdown-item command="dark">深色</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-switch
              v-show="openElderlyMode"
              v-model="oldModel"
              @change="toggleFont"
              inactive-text="长者模式"
              active-color="#0067DD"
              inactive-color="#374768">
            </el-switch>
            <el-dropdown @command="changeLanguage" v-show="openLangSwitch">
              <span class="el-dropdown-link">
                语言切换<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="zh-CN">中文</el-dropdown-item>
                <el-dropdown-item command="en">英文</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="chat-wrapper" ref="chatWrapper">
            <div class="chat-wrap" id="chat-wrap" ref="chatWrap">
              <!-- 对话 -->
              <div
                :class="[
                  'chat-item',
                  { other: message.type == ANSWER || message.type === WELCOME},
                  { self: message.type == QUESTION },
                ]"
                v-for="message in messageList"
                :key="message.id"
                :id="`m-${message.id}`"
              >
                <!-- 回答或开场推荐 -->
                <template v-if="message.type === ANSWER || message.type === WELCOME">
                  <div class="avatar">
                    <img :src="robotHeadUrl" v-if="webEquipmentType" />
                    <div v-else class="answer-logo">
                      <img :src="robotHeadUrl" />
                      政务问答{{ aiName }}
                    </div>
                    <div class="right-body">
                      <div class="talk" :class="(!webEquipmentType) && (message.type === ANSWER) ? 'whitebg':''">
                        <div v-if="!(message.status === ChatStatus.Pending || (message.status === ChatStatus.Answering && !message.content))">
                          <div class="tuijian" v-if="!webEquipmentType && message.type === WELCOME" >
                            <div class="tuijian-header">
                              <div class="left">
                                <div class="left-line">
                                  <img src="../assets/img/index/Hi.png" alt="">
                                  我是智能客服{{ aiName }}！
                                </div>
                                <div class="left-intro">
                                  有什么问题您可以问我，我会尽力帮您解答！
                                </div>
                              </div>
                              <img src="../assets/img/index/mtuijian.png" alt="">
                            </div>
                            <div class="tuijian-items">
                              <div class="tuijian-item" v-for="(item,index) in hotQuestion" :key="index">
                                {{ item.question }}
                                <i class="ri-arrow-right-s-line"></i>
                              </div>
                            </div>
                          </div>
                          <span v-else style="margin: 0;"> {{ message.title }}</span>
                        </div>

                        <div class="message" v-if="webEquipmentType">
                          <div class="text">
                            <div class="wrap">
                              <!-- 思考 -->
                              <div v-if="
                                  message.status === ChatStatus.Pending ||
                                  (message.status === ChatStatus.Answering &&
                                  !message.content)
                                ">
                                <i class="el-icon-loading"></i>
                                “{{ aiName }}”正在思考
                              </div>

                              <!-- 开场推荐 -->
                              <div class="chat-tip" v-if="message.type === WELCOME && openWelcome">
                                <div class="tuijian-list">
                                  <div class="list-top">
                                    <div><span>为您推荐</span></div>
                                    <div style="display: none">
                                      <i class="ri-refresh-line"></i>
                                      换一批
                                    </div>
                                  </div>
                                  <div class="lists">
                                    <div class="list-item">
                                      <div class="name">
                                        <img src="../assets/img/index/icontj1.png" alt="">
                                        猜你想问
                                      </div>
                                      <ul>
                                        <li v-for="(question, index) in guessQuestion" :key="index" @click="submitInput(question.question)">
                                          <div class="text">{{ question.question }}</div>
                                        </li>
                                      </ul>
                                    </div>
                                    <div class="list-item">
                                      <div class="name">
                                        <img src="../assets/img/index/icontj2.png" alt="">
                                        热门问题
                                      </div>
                                      <ul>
                                        <li v-for="(question, index) in hotQuestion" :key="index" @click="submitInput(question.question)">
                                          <div class="text">{{ question.question }}</div>
                                        </li>
                                      </ul>
                                    </div>
                                    <div class="list-item">
                                      <div class="name">
                                        <img src="../assets/img/index/icontj3.png" alt="">
                                        一键直达
                                      </div>
                                      <ul>
                                        <li v-for="(item, index) in hotItems" :key="index" @click="submitInput(item.itemName)">
                                          <div class="text">{{ item.itemName }}</div>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- 流式MD文本回复 -->
                              <div class="chat-tip" v-if="message.answerType === 'text'">
                                <the-markdown
                                    id="currentContent"
                                    v-if="message.status !== ChatStatus.Pending"
                                    :enable-delay="message.enableDelay"
                                    :source="message.content"
                                    :source-finished="message.contentFinished"
                                    :think="message.think"
                                    :think-finished="message.thinkFinished"
                                    :anchor-attributes="anchorAttrs"
                                >
                                </the-markdown>
                              </div>

                              <!-- 推荐服务 -->
                              <div class="tab-table" v-if="message.answerType === 'bsfw'">
                                <el-tabs v-model="chatActiveName" type="card">
                                  <el-tab-pane v-if="message.itemList && message.itemList.length > 0" label="政务服务" name="first"></el-tab-pane>
                                  <el-tab-pane v-if="message.policyList && message.policyList.length > 0" label="政策法规" name="second"></el-tab-pane>
                                </el-tabs>
                                <div class="lists" v-if="chatActiveName === 'first'">
                                    <div class="list-item" v-for="(item, index) in message.pagedItemList" @click="() => submitInput(item.itemName)" :key="new Date() + index">
                                      <img src="../assets/img/index/iconfw3.png" alt="">
                                      <div class="text" style="border-radius: 0;">{{ item.itemName }}</div>
                                    </div>
                                </div>
                                <div class="pagination" v-if="chatActiveName === 'first'">
                                  <el-pagination
                                      :page-size="itemPage.pageSize"
                                      :current-page="itemPage.currentPage"
                                      :total="itemPage.total"
                                      @current-change="(currentPage) => handleItemPageChange(currentPage, message)"
                                      layout="prev, slot, next">
                                    <template slot>
                                      <span class="custom-text">
                                        {{ itemPage.show }}
                                      </span>
                                    </template>
                                  </el-pagination>
                                </div>
                                <div class="lists-zhengce" v-if="chatActiveName === 'second'">
                                  <div class="list-item" v-for="(item,index) in message.policyList" :key="new Date() + index">
                                    <div class="title">
                                      {{ item.name }}
                                    </div>
                                    <img :src="item.img" alt="">
                                    <div class="text">
                                      {{ item.content }}
                                    </div>
                                    <div class="from">
                                      <img :src="item.icon" alt="">
                                      <div class="from-name">{{ item.from }}</div>
                                    </div>
                                  </div>
                                </div>
                                <div class="pagination" v-if="chatActiveName === 'second'">
                                  <el-pagination
                                      :page-size="policyPage.pageSize"
                                      :current-page="policyPage.currentPage"
                                      :total="policyPage.total"
                                      @current-change="(currentPage) => handlePolicyPageChange(currentPage, message)"
                                      layout="prev, slot, next">
                                    <template slot>
                                      <span class="custom-text">
                                        {{ policyPage.show }}
                                      </span>
                                    </template>
                                  </el-pagination>
                                </div>
                              </div>

                              <!-- 办事指南 -->
                              <div class="info-table" v-if="message.answerType === 'bszn' && message.itemInfo">
                                <el-tabs v-model="chatActiveName2" type="card">
                                  <el-tab-pane label="基本信息" name="first">
                                    <el-descriptions class="margin-top" :column="2" :size="'medium'" :labelStyle="{ fontWeight: 600}">
                                      <el-descriptions-item label="事项名称">
                                        {{ message.itemInfo['item_name'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="事项类型">
                                        {{ message.itemInfo['基本信息']['事项类型'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="实施主体">
                                        {{ message.itemInfo['基本信息']['实施主体'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="行使层级">
                                        {{ message.itemInfo['基本信息']['行使层级'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="服务对象">
                                        {{ message.itemInfo['基本信息']['服务对象'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="办理形式">
                                        {{ message.itemInfo['基本信息']['办理形式'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="是否收费">
                                        {{ message.itemInfo['基本信息']['审批收费'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="收费标准">
                                        {{ message.itemInfo['基本信息']['收费标准'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="法定办结时限">
                                        {{ message.itemInfo['基本信息']['法定办结时限'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="承诺办结时限">
                                        {{ message.itemInfo['基本信息']['承诺办结时限'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="办理结果" :span="2">
                                        {{ message.itemInfo['基本信息']['办理结果名称'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="办理地点" :span="2">
                                        {{ message.itemInfo['基本信息']['窗口查询地址'] || message.itemInfo['基本信息']['窗口地址'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="办理时间" :span="2">
                                        {{ message.itemInfo['基本信息']['窗口查询工作时间'] || message.itemInfo['基本信息']['窗口工作时间'] }}
                                      </el-descriptions-item>
                                    </el-descriptions>
                                  </el-tab-pane>
                                  <el-tab-pane label="受理条件" name="second" v-if="message.itemInfo['受理条件']">
                                    {{ message.itemInfo['受理条件'][0]['受理条件']}}
                                  </el-tab-pane>
                                  <el-tab-pane label="申请材料" name="third">
                                    <el-table :data="message.itemInfo['申请材料']" style="width: 100%">
                                      <el-table-column prop="材料名称" label="材料名称" width="220"></el-table-column>
                                      <el-table-column prop="材料类型" label="材料类型"></el-table-column>
                                      <el-table-column prop="材料形式" label="材料形式"></el-table-column>
                                      <el-table-column prop="来源渠道" label="来源渠道"></el-table-column>
                                      <el-table-column prop="纸质材料份数" label="纸质材料份数"></el-table-column>
                                      <el-table-column prop="材料必要性" label="材料必要性"></el-table-column>
                                      <el-table-column prop="填报须知" label="填报须知" width="220"></el-table-column>
                                    </el-table>
                                  </el-tab-pane>
                                  <el-tab-pane label="设定依据" name="second" v-if="message.itemInfo['设立依据']">
                                    {{ message.itemInfo['基本信息']['设立依据']}}
                                  </el-tab-pane>
                                  <el-tab-pane label="常见问题" name="second" v-if="message.itemInfo['常见问题']">
                                    {{ message.itemInfo['基本信息']['常见问题']}}
                                  </el-tab-pane>
                                </el-tabs>
                              </div>

                              <!-- 我要办理 -->
                              <div class="my-handle" v-if="message.itemInfo && message.itemInfo['基本信息']['网址']">
                                <div class="text">如果您对办这个事项已有了解，您也可以点击“我要办理”，直接进入办理环节。</div>
                                <el-button class="btn-handle" @click="() => goApply(message.itemInfo['基本信息']['网址'])">我要办理</el-button>
                              </div>

                              <!-- 二维码 -->
                              <div
                                v-if="
                                  message.status === ChatStatus.Finished &&
                                  message.answerType &&
                                  message.eaUrl &&
                                  message.eaUrl.length > 0
                                "
                                class="finished-tool"
                              >
                                <el-button
                                  size="small"
                                  type="primary"
                                  @click="onShowQrCode(message)"
                                  >点击扫码</el-button
                                >
                              </div>

                              <!-- 推荐事项 -->
                              <div
                                v-if="
                                  message.status === ChatStatus.Finished &&
                                  // message.answerType &&
                                  message.rag_item &&
                                  message.rag_item.length > 0
                                "
                                class="buttonContainer"
                              >
                                <el-button
                                  type="text"
                                  size="medium"
                                  style="
                                    color: #266feb;
                                    border: 1px solid #dcdfe6;
                                    border-radius: 20px;
                                  "
                                  v-for="(item, index) in message.rag_buttons"
                                  :key="index"
                                  @click="ragbuttonHandle(item)"
                                  >{{ item }}</el-button
                                >
                              </div>
                            </div>
                          </div>
                          <div class="ai-tip" v-if="aiTip && message.type === ANSWER && message.status === ChatStatus.Finished">
                            <i class="el-icon-warning-outline" style="margin-right: 4px"></i>{{aiTip}}
                          </div>
                        </div>

                        <div class="message mobile" v-if="!webEquipmentType">
                          <div class="text">
                            <div class="wrap">
                              <div v-if="
                                  message.status === ChatStatus.Pending ||
                                  (message.status === ChatStatus.Answering &&
                                  !message.content)
                                ">
                                <i class="el-icon-loading"></i>
                                “{{ aiName }}”正在思考
                              </div>
                              <div class="ec-message__text"
                                v-if="
                                  message.status === ChatStatus.Pending ||
                                  (message.status === ChatStatus.Answering &&
                                  !message.content)
                                ">
                                <ec-typed-text
                                  :ref="`typedRef_${message.id}`"
                                  @onComplete="handleTypedComplete(message)"
                                  :strings="[sikaoContent]"
                                  :contentType="`html`"
                                  :startDelay="25"
                                  :typeSpeed="25"
                                  :showCursor="false"
                                >
                                  <span class="typing"></span>
                                </ec-typed-text>
                              </div>

<!--                              <div class="total" v-if="false">-->
<!--                                <div class="knows">-->
<!--                                  <span><i class="ri-global-line"></i></span>-->
<!--                                  检索到 15 篇相关知识-->
<!--                                  <i class="ri-arrow-down-s-line"></i>-->
<!--                                </div>-->
<!--                                <div class="thinks">-->
<!--                                  <span><i class="ri-reactjs-line"></i></span>-->
<!--                                  已深度思考（用时 37 秒）-->
<!--                                  <i class="ri-arrow-down-s-line"></i>-->
<!--                                </div>-->
<!--                              </div>-->

                              <!-- 移动端办事服务 -->
                              <div class="tab-table2" v-if="message.answerType === 'bsfw'">
                                <el-tabs v-model="chatActiveName3" type="card" v-show="false">
                                  <el-tab-pane v-if="message.itemList && message.itemList.length > 0" label="政务服务" name="first"></el-tab-pane>
                                  <el-tab-pane v-if="message.policyList && message.policyList.length > 0" label="政策法规" name="second"></el-tab-pane>
                                </el-tabs>

                                <div class="lists" v-if="chatActiveName3 === 'first'">
                                  <div class="list-item" v-for="(item,index) in message.itemList" :key="index" @click="() => submitInput(item.itemName)">
                                    <div class="left">
                                      <img src="../assets/img/index/iconfw3.png" alt="">
                                      <div class="text" style="border-radius: 0;">{{ item.itemName }}</div>
                                    </div>
                                    <i class="ri-arrow-right-s-line"></i>
                                  </div>
                                </div>

                                <div class="lists" v-if="chatActiveName3 === 'second'">
                                  <div class="list-item" v-for="(item,index) in message.policyList" :key="index">
                                    <div class="left">
                                      <img :src="item.img" alt="">
                                      <div class="text">{{ item.name }}</div>
                                    </div>
                                    <i class="ri-arrow-right-s-line"></i>
                                  </div>
                                </div>
                              </div>

                              <!-- 移动端办事指南 -->
                              <div class="info-table" v-if="message.answerType === 'bszn' && message.itemInfo">
                                <el-tabs v-model="chatActiveName2" type="card">
                                  <el-tab-pane label="基本信息" name="first">
                                    <el-descriptions class="margin-top" :column="1" :size="'medium'" :labelStyle="{ fontWeight: 600}">
                                      <el-descriptions-item label="事项名称">
                                        {{ message.itemInfo['item_name'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="事项类型">
                                        {{ message.itemInfo['基本信息']['事项类型'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="实施主体">
                                        {{ message.itemInfo['基本信息']['实施主体'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="行使层级">
                                        {{ message.itemInfo['基本信息']['行使层级'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="服务对象">
                                        {{ message.itemInfo['基本信息']['服务对象'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="办理形式">
                                        {{ message.itemInfo['基本信息']['办理形式'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="是否收费">
                                        {{ message.itemInfo['基本信息']['审批收费'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="收费标准">
                                        {{ message.itemInfo['基本信息']['收费标准'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="法定办结时限">
                                        {{ message.itemInfo['基本信息']['法定办结时限'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="承诺办结时限">
                                        {{ message.itemInfo['基本信息']['承诺办结时限'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="办理结果" :span="2">
                                        {{ message.itemInfo['基本信息']['办理结果名称'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="办理地点" :span="2">
                                        {{ message.itemInfo['基本信息']['窗口查询地址'] || message.itemInfo['基本信息']['窗口地址'] }}
                                      </el-descriptions-item>
                                      <el-descriptions-item label="办理时间" :span="2">
                                        {{ message.itemInfo['基本信息']['窗口查询工作时间'] || message.itemInfo['基本信息']['窗口工作时间'] }}
                                      </el-descriptions-item>
                                    </el-descriptions>
                                  </el-tab-pane>
                                  <el-tab-pane label="受理条件" name="second" v-if="message.itemInfo['受理条件']">
                                    {{ message.itemInfo['受理条件'][0]['受理条件']}}
                                  </el-tab-pane>
                                  <el-tab-pane label="申请材料" name="third">
                                    <div class="materials" v-for="(material, index) in message.itemInfo['申请材料']" :key="index">
                                      <div>{{ index + 1 }}、{{material['材料名称']}}</div>
                                      <div class="material">
                                        <div class="label">材料类型：</div>
                                        <div class="value">{{ material['材料类型'] }}</div>
                                      </div>
                                      <div class="material">
                                        <div class="label">材料形式：</div>
                                        <div class="value">{{ material['材料形式'] }}</div>
                                      </div>
                                      <div class="material">
                                        <div class="label">来源渠道：</div>
                                        <div class="value">{{ material['来源渠道'] }}</div>
                                      </div>
                                      <div class="material">
                                        <div class="label">纸质份数：</div>
                                        <div class="value">{{ material['纸质材料份数'] }}</div>
                                      </div>
                                      <div class="material">
                                        <div class="label">是否必要：</div>
                                        <div class="value">{{ material['材料必要性'] }}</div>
                                      </div>
                                      <div class="material">
                                        <div class="label">填报须知：</div>
                                        <div class="value">{{ material['填报须知'] }}</div>
                                      </div>
                                    </div>
                                  </el-tab-pane>
                                  <el-tab-pane label="设定依据" name="second" v-if="message.itemInfo['设立依据']">
                                    {{ message.itemInfo['基本信息']['设立依据']}}
                                  </el-tab-pane>
                                  <el-tab-pane label="常见问题" name="second" v-if="message.itemInfo['常见问题']">
                                    {{ message.itemInfo['基本信息']['常见问题']}}
                                  </el-tab-pane>
                                </el-tabs>
                              </div>

                              <!-- 流式MD文本回复 -->
                              <div class="chat-tip" v-if="message.answerType === 'text'">
                                <the-markdown
                                    id="currentContent"
                                    v-if="message.status !== ChatStatus.Pending"
                                    :enable-delay="message.enableDelay"
                                    :source="message.content"
                                    :source-finished="message.contentFinished"
                                    :think="message.think"
                                    :think-finished="message.thinkFinished"
                                    :anchor-attributes="anchorAttrs"
                                >
                                </the-markdown>
                              </div>

                              <!-- 我要办理 -->
                              <div class="my-handle" v-if="message.itemInfo && message.itemInfo['基本信息']['网址']">
<!--                                <div class="text">如果您对办这个事项已有了解，您也可以点击“我要办理”，直接进入办理环节。</div>-->
                                <el-button class="btn-handle" @click="() => goApply(message.itemInfo['基本信息']['网址'])">我要办理</el-button>
                              </div>

<!--                              <div class="more-history" v-if="false">-->
<!--                                <el-button>更多</el-button>-->
<!--                              </div>-->
                              <div
                                v-if="
                                  message.status === ChatStatus.Finished &&
                                  message.answerType &&
                                  message.eaUrl &&
                                  message.eaUrl.length > 0
                                "
                                class="finished-tool"
                              >
                                <el-button
                                  size="small"
                                  type="primary"
                                  @click="onShowQrCode(message)"
                                  >点击扫码</el-button
                                >
                              </div>

                              <!-- 推荐事项 -->
                              <div
                                v-if="
                                  message.status === ChatStatus.Finished &&
                                  // message.answerType &&
                                  message.rag_item &&
                                  message.rag_item.length > 0
                                "
                                class="buttonContainer"
                              >
                                <el-button
                                  type="text"
                                  size="medium"
                                  style="
                                    color: #266feb;
                                    border: 1px solid #dcdfe6;
                                    border-radius: 20px;
                                  "
                                  v-for="(item, index) in message.rag_buttons"
                                  :key="index"
                                  @click="ragbuttonHandle(item)"
                                  >{{ item }}</el-button
                                >
                              </div>

                              <div
                                v-if="
                                  message.status === ChatStatus.Finished &&
                                  message.answerType &&
                                  message.matched_button &&
                                  message.matched_button.length > 0
                                "
                                class="buttonContainer"
                              >
                                <el-button
                                  v-for="(item, index) in buttons"
                                  :key="index"
                                  size="small"
                                  type="primary"
                                  @click="buttonHandle(message.content, item)"
                                  >{{ item }}</el-button
                                >
                              </div>

                              <!-- 开场推荐下方的事项 -->
                              <div class="my-handle" v-if="message.type === WELCOME">
                                <div class="text">
                                  为您推荐
                                  <i class="ri-arrow-up-s-line"></i>
                                </div>
                                <div class="tuijian-list">
                                  <div class="item" v-for="(item, index) in hotItems" :key="index">
                                    {{ index + 1 }}、[办事服务]{{ item.itemName }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="ai-tip" v-if="aiTip && message.type === ANSWER && message.status === ChatStatus.Finished">
                            <i class="el-icon-warning-outline" style="margin-right: 4px"></i>{{aiTip}}
                          </div>
                        </div>

                      </div>
                      <div class="talk-buttom"  v-if="message.answer_type === 'text'">
<!--                        <div class="left-button">-->
<!--                          <el-button-->
<!--                            @click="handleCopy(message.content)"-->
<!--                            title="复制"-->
<!--                            style="border: none; padding: 0 5px"-->
<!--                          >-->
<!--                            <i class="ri-refresh-line"></i>-->
<!--                            重新生成-->
<!--                          </el-button>-->
<!--                        </div>-->
                        <div
                          class="icon-buttons"
                        >
                          <el-button
                            @click="handleCopy(message.content)"
                            title="复制"
                            style="border: none; padding: 0 5px"
                          >
                            <i class="ri-file-copy-line"></i>
                          </el-button>
                          <el-button
                            title="下载"
                            style="border: none; padding: 0 5px; display: none;"
                          >
                            <i class="ri-download-line"></i>
                          </el-button>
                          <el-button
                            title="播放"
                            style="border: none; padding: 0 5px; display: none;"
                          >
                            <i class="ri-video-line"></i>
                          </el-button>
                          <div class="ver-line"></div>
                          <el-button
                            @click="handleLike(message.content, message.id)"
                            title="喜欢"
                            style="border: none; padding: 0 5px"
                          >
                            <i
                              class="ri-thumb-up-line"
                              :id="'like' + message.id"
                            ></i>
                          </el-button>
                          <el-button
                            @click="handleDislike(message.content, message.id)"
                            title="不喜欢"
                            style="border: none; padding: 0 5px"
                          >
                            <i
                              class="ri-thumb-down-line"
                              :id="message.id"
                            ></i>
                          </el-button>
                          <el-button
                            @click="handleToggleTts(message.content)"
                            title="语音开关"
                            style="border: none; padding: 0 5px"
                            v-show="
                              enableTts &&
                              message.id ===
                                messageList[messageList.length - 1].id
                            "
                          >
                            <img
                              :src="playAudioFlag ? volumeOn : volumeMute"
                              alt="语音开关图标"
                              width="20"
                              height="20"
                              :id="message.id"
                            />
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- 问题 -->
                <template v-else>
                  <div class="message">
                    <div class="text">
                      <div class="wrap" v-html="message.content"></div>
                    </div>
                  </div>
                  <div class="avatar" v-if="webEquipmentType">
                    <img :src="userAvatarUrl" />
                  </div>
                </template>
              </div>
              <div
                class="stop-answer"
                v-show="
                  currentAnswer &&
                  currentAnswer.message &&
                  currentAnswer.message.taskId
                "
              >
                <el-button
                  class="btn-stop-answer"
                  icon="el-icon-chat-dot-square"
                  @click="onOpenNewSession"
                  >开启新对话</el-button
                >
              </div>
              <div id="pointer" style="margin-top: 140px"></div>
            </div>
          </div>

          <!-- 输入框 -->
          <div class="input-wrap" v-if="webEquipmentType">
            <img :src="guideimg" class="logo" v-if="shouldShowImage" />

            <!-- 推荐主题 -->
            <div class="word-list" v-show="openSuggestTheme">
              <div class="name">推荐主题：</div>
              <div class="swiper-container" id="mySwiper">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="(item, index) in suggestTheme" :key="index" @click="clickSuggestTheme(item.name)">
                    {{ item.name }}
                  </div>
                </div>
              </div>
              <div class="swiper-button-prev"></div>
              <div class="swiper-button-next"></div>
            </div>

            <TheInput
              :status="
                currentAnswer &&
                currentAnswer.message &&
                currentAnswer.message.taskId &&
                currentAnswer.message.status
              "
              @confirm="submitInput"
              @stop="onStopChatMessage"
            ></TheInput>
          </div>
          <div class="input-wrap-mobile" v-if="!webEquipmentType">
            <div class="word-list">
              <div class="list-item" v-for="(item,index) in suggestTheme" :key="index" @click="clickSuggestTheme(item.name)">
                {{ item.name }}
              </div>
            </div>
            <TheInputMobile
              :status="
                currentAnswer &&
                currentAnswer.message &&
                currentAnswer.message.taskId &&
                currentAnswer.message.status
              "
              @confirm="submitInput"
              @stop="onStopChatMessage"
            ></TheInputMobile>
          </div>
        </div>
      </div>
      <div class="mobile-history" v-if="mactiveName === 'second'">
        <TheSessionHistoryMobile
          class="drawer-history"
          :list="sessionHistory"
          @openNewSession="onOpenNewSession"
          @click="onHistoryClick"
          @clearClick="onClearClick"
          @delSessionItem="onDelSessionItem"
        ></TheSessionHistoryMobile>
      </div>
    </div>

    <el-dialog
      title="二维码扫描"
      :visible.sync="qrCodeDialogVisible"
      width="30%"
    >
      <img :src="qrcode" alt="" class="qrcode-img" />
    </el-dialog>
  </div>
</template>
<script>
// import {Swiper} from '../util/swiper/swiper-bundle.min.js';
// Import Swiper Vue.js components
import Cookies from 'js-cookie';
import {v4} from "uuid";
import  Swiper  from 'swiper';
// Import Swiper styles
import 'swiper';
import _ from "lodash";
// import VueMarkdown from "vue-markdown";
import QRCode from "qrcode";
import PCMPlayer from "pcm-player";
import { mapState } from "vuex";
import { chatApi } from "@/api/chat-api";
import ScrollListener from "@/util/ScrollListener";
import EcTypedText from '@/components/EcTypedText'
const ANSWER = "answer";
const QUESTION = "question";
const WELCOME = "welcome";
const ChatStatus = {
  Pending: "Pending",
  Answering: "Answering",
  Finished: "Finished",
  Stop: "Stop",
  Fail: "Fail",
};

export default {
  components: {
    // TheHeader: () => import("@comp/TheHeader.vue"),
    //TheHot: () => import("@comp/TheHot.vue"),
    // TheHistory: () => import("@comp/TheHistory.vue"),
    TheInput: () => import("@comp/TheInput.vue"),
    TheInputMobile: () => import("@comp/TheInputMobile.vue"),
    // TheMarkdown: () => import("@comp/TheMarkdown.vue"),
    TheMarkdown: () => import("@comp/TheMarkdown.vue"),
    TheSessionHistory: () => import("@comp/TheSessionHistory.vue"),
    TheSessionHistoryMobile: () => import("@comp/TheSessionHistoryMobile.vue"),
    ThePersonPage: () => import("@comp/ThePersonPage.vue"),
    TheTool: () => import("@comp/TheTool.vue"),
    // VueMarkdown,
    EcTypedText,
    // Swiper,
    // SwiperSlide,
  },
  data() {
    return {
      ChatStatus,
      isLiked: false,
      likeImage: require("@/assets/img/thumb-up-line.svg"),
      likedImage: require("@/assets/img/thumb-up-fill.svg"),
      disisLiked: false,
      dislikeImage: require("@/assets/img/thumb-down-line.svg"),
      dislikedImage: require("@/assets/img/thumb-down-fill.svg"),
      guideimg: require("@/assets/img/robot-wave.png"),
      volumeOn: require("@/assets/img/volume-on.svg"),
      volumeMute: require("@/assets/img/volume-mute.svg"),
      inputMessage: "",
      messageList: [],
      feedbackid: "",
      ANSWER: ANSWER,
      QUESTION: QUESTION,
      WELCOME: WELCOME,
      inputPopoverShow: false,
      inputPopoverTimeoutHandler: null,
      buttons: [],
      anchorAttrs: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
      },
      questionMessage: "",
      conversationMess: [], // 存储 AI和用户 会话消息

      searchHistory: [],
      tempInputs: {
        base_district: this.baseDistrict,
        ai_name: this.aiName
      },
      qrCodeDialogVisible: false,
      qrcode: "",
      userId: "",

      showVideoInputing: true,

      sessionHistory: [
        /* {
            id: '',
            chatMessages: [],
            chatTempInputs: {},
            timestamp: ''
          }*/
      ],
      currentSessionId: "",

      answerAutoScrollTimer: "",
      scrollListener: "",
      hasUserScrollInAnswering: false,
      conversationId: "",

      // tts text
      ttsText: "",
      // ws对象
      websocket: null,
      // 语音合成session
      ttsSession: "",
      // 语音合成ws开关
      ttsRealClose: true,
      // 合成语音WS心跳时间超时时间
      ttsHeartTimerTimeout: 10000,
      // 合成语音WS心跳定时任务
      ttsHeartTimer: null,
      // 合成语音WS重连锁
      ttsWsReconnectLock: false,
      // 合成语音重连定时任务对象
      ttsWsReconnectTimer: null,
      // 合成语音WS客户端监听心跳定时器
      ttsWsTimeoutObj: null,
      // 合成语音音WS服务器端返回监听心跳定时器
      ttsWsServerTimeoutObj: null,
      // 处理PCM音频流的对象
      player: null,
      playAudioEndIndex: 0,
      playAudioFlag: false,
      playAudioTimer: null,
      drawer: false,
      oldModel: false,
      chatActiveName:'first',
      fuwuList:[
        {
          img:require('../assets/img/index/iconfw1.png'),
          name:'住房公积金个人账户设立',
        },
        {
          img:require('../assets/img/index/iconfw2.png'),
          name:'住房公积金单位缴存登记',
        },
        {
          img:require('../assets/img/index/iconfw3.png'),
          name:'住房公积金个人账户信息变更',
        },
        {
          img:require('../assets/img/index/iconfw4.png'),
          name:'住房公积金单位缴存登记',
        },
      ],
      faguiList:[
        {
          img:'',
          name:'政策法规（党政机关制定的文件）-百科',
          content:'政策法规就是党政机关制定的关于处理党内和政府事务工作的文件。',
          icon:require('../assets/img/index/iconfrom1.png'),
          from:'抖音百科',
        },
        {
          img:'',
          name:'政策法规',
          content:'海关总署公告2022年第129号（关于《区域全面经济伙伴关系协定》实施新增事宜的公告）2023-01-02...',
          icon:require('../assets/img/index/iconfrom2.png'),
          from:'中华人民共和国海关',
        },
        {
          img:'',
          name:'政策法规中华人民共和国人力资源和社会保障部',
          content:'关于进一步规范职业技能培训管理工作的通知，2024年1月11',
          icon:require('../assets/img/index/iconfrom3.png'),
          from:'中华人民共和国还关',
        },
        {
          img:require('../assets/img/index/image.png'),
          name:'住房公积金单位缴存登记',
          content:'',
          icon:require('../assets/img/index/iconfrom3.png'),
          from:'国务院国资委',
        },
        {
          img:'',
          name:'政策法规',
          content:'海关总署公告2022年第129号（关于《区域全面经济伙伴关系协定》实施新增事宜的公告）2023-01-02...',
          icon:require('../assets/img/index/iconfrom2.png'),
          from:'中华人民共和国海关',
        },
      ],
      itemPage: {
        total: 16,
        currentPage: 1,
        pageSize:4,
        show: "",
      },
      policyPage: {
        total: 16,
        currentPage: 1,
        pageSize: 4,
        show: "",
      },
      chatActiveName2:'first',
      mySwiper:'',
      swiperList:[
        '身份证','机动车驾驶','社会保障卡','养老保险','居民户口','结婚登记',
        '公积金贷款','公积金提取','身份证','社会保障卡','养老保险','居民户口'
      ],
      mactiveName:'first',
      windowWidth: window.innerWidth,
      webEquipmentType: true,
      mTuijianList:[
        '有效期届满延续','变更企业名称','变更企业注册地','变更企业法定代表人'
      ],
      sikaoContent:'',
      chatActiveName3:'first',
      fuwuList2:[
        {
          img:require('../assets/img/index/iconfw1.png'),
          name:'住房公积金个人账户设立',
        },
        {
          img:require('../assets/img/index/iconfw2.png'),
          name:'住房公积金单位缴存登记',
        },
        {
          img:require('../assets/img/index/iconfw3.png'),
          name:'住房公积金个人账户信息变更',
        },
        {
          img:require('../assets/img/index/iconfw4.png'),
          name:'住房公积金单位缴存登记',
        },
      ],
      mobileTips:[
        '词汇1','词汇1','词汇1','词汇1','词汇1','词汇1','词汇1','词汇1','词汇1'
      ],
      // currentThemeStyle: this.$store.state.style.systemStyle.theme,
    };
  },
  computed: {
    ...mapState({
      reasoningModel: (state) => state.business.sysConfig.reasoningModel,
      useConversationId: (state) => state.business.sysConfig.useConversationId,
      WelcomeText: (state) => state.business.sysConfig.WelcomeText,
      WelcomeTitle: (state) => state.business.sysConfig.WelcomeTitle,
      ttsWsUrl: (state) => state.business.sysConfig.ttsWsUrl,
      enableTts: (state) => state.business.sysConfig.enableTts,
      displayCartoon: (state) => state.business.sysConfig.displayCartoon,
      enableAvatar: (state) => state.business.sysConfig.enableAvatar,
      PageTitle: (state) => state.business.sysConfig.PageTitle,
      LogoName: (state) => state.business.sysConfig.LogoName,
      LogoImgUrl: (state) => state.business.sysConfig.LogoImgUrl,
      districtFlag: (state) => state.business.sysConfig.districtFlag,
      chatBgUrl: (state) => state.business.sysConfig.chatBgUrl,
      robotHeadUrl: (state) => state.business.sysConfig.robotHeadUrl,
      userAvatarUrl: (state) => state.business.sysConfig.userAvatarUrl,
      enableMessageStreamDelay: (state) => state.business.sysConfig.enableMessageStreamDelay,
      aiTip: (state) => state.business.sysConfig.AiTip,
      projectCode: (state) => state.business.pageCode,
      // 标题
      title: (state) => {
        document.title = state.business.sysConfig.title
        return state.business.sysConfig.title
      },
      // 区划
      baseDistrict: (state) => state.business.sysConfig.baseDistrict,
      // 助手名称
      aiName: (state) => state.business.sysConfig.aiName,
      // 猜你想问
      guessQuestion: (state) => state.business.sysConfig.guessQuestion,
      // 热门问题
      hotQuestion: (state) => state.business.sysConfig.hotQuestion,
      // 一键直达
      hotItems: (state) => state.business.sysConfig.hotItems,
      // 推荐主题
      suggestTheme: (state) => state.business.sysConfig.suggestTheme,
      // 主题
      currentThemeStyle: (state) => state.business.sysConfig.theme || 'light',
      // 开启长者模式
      openElderlyMode: (state) => state.business.sysConfig.openElderlyMode || false,
      // 开启开场推荐
      openWelcome: (state) => state.business.sysConfig.openWelcome || false,
      // 开启推荐主题
      openSuggestTheme: (state) => state.business.sysConfig.openSuggestTheme || false,
      // 开启语言切换
      openLangSwitch: (state) => state.business.sysConfig.openLangSwitch || false,
    }),
    currentAnswer() {
      const index = this.messageList.findLastIndex(
        (item) => item.type === ANSWER
      );
      return {
        index: index,
        message: this.messageList[index],
      };
    },
    shouldShowImage() {
      return this.displayCartoon;
    },
  },
  created(){},
  methods: {
    getUserId() {
      if (this.userId) {
        return this.userId
      }
      // 获取cookie的值
      let uid = Cookies.get('znwd_chat_uid'); // 获取名为 'username' 的cookie的值
      if (uid) {
        this.userId = uid
        return this.userId
      }

      uid = v4()
      this.userId = uid
      Cookies.set('znwd_chat_uid', uid, { expires: 365 });
      return this.userId
    },
    clickSuggestTheme(theme) {
      this.currentSessionId = "";
      this.conversationId = "";
      this.messageList = []
      this.sendWelcomeText();
      this.resetTempInputs();
      this.submitInput(theme)
    },
    changePageClass(){
      // 获取div元素
        var div = document.getElementById("allPage");
        // 添加类
        div.classList.add("lightTheme");
    },
    handleTypedComplete (row) {
      console.log(row);
    },
    changeTheme(command){
      this.currentThemeStyle = command
    },
    handleMobileTabClick(tab, event) {
      console.log(tab, event);
    },
    initSwiper() {
      if (this.mySwiper) {
        this.mySwiper.destroy(); // 销毁旧的Swiper实例
      }
      this.mySwiper = new Swiper('#mySwiper', {
        // loop: true, // 循环模式
        slidesPerView: 9,  // 同时显示5个slide
        initialSlide: 0,
        watchOverflow: true,
        spaceBetween: 12,
        // centeredSlides: true,  // 居中显示
        uniqueNavElements: false,
        navigation: {
          nextEl: '.swiper-button-next', // 下一页按钮
          prevEl: '.swiper-button-prev', // 上一页按钮
        },
      });
    },
    goApply(url) {
      window.open(url, '_blank')
    },
    handleItemPageChange(currentPage, message) {
      let pageSize = this.itemPage.pageSize;
      console.log(currentPage);
      this.itemPage.show = currentPage + '/'+ Math.ceil(this.itemPage.total / pageSize)
      //处理分页数据
      message.pagedItemList = message.itemList.slice((currentPage - 1) * pageSize, currentPage * pageSize)
    },
    handlePolicyPageChange(currentPage, message) {
      let pageSize = this.policyPage.pageSize;
      this.policyPage.show = currentPage + '/'+ Math.ceil(this.policyPage.total / pageSize)
      //处理分页数据
      message.pagedPolicyList = message.policyList.slice((currentPage - 1) * pageSize, currentPage * pageSize)
    },
    async toggleFont() {
      await this.$store.dispatch("style/toggleFontSize");
    },
    handleToggleTts(content) {
      if (this.playAudioFlag) {
        this.stopAudioPlay();
      } else {
        if (this.ttsSession) {
          this.wsSendMessage(content);
        } else {
          this.initWebSocket();
          this.initPCMPlayer();
          this.wsSendMessage(content);
        }
      }
    },

    // 初始化音频对象
    initPCMPlayer() {
      this.player = new PCMPlayer({
        encoding: "16bitInt", // 采样位数
        channels: 1, // 通道
        sampleRate: 24000, // 采样率
        flushingTime: 100, // pcm刷新间隔
        onstatechange: () => {},
        // 播放结束事件
        onended: () => {
          // this.resetInactivityTimer(); // 重置全局倒计时
          // 处理其他播放结束逻辑
          if (this.playAudioTimer != null) {
            clearTimeout(this.playAudioTimer);
          }
          this.playAudioTimer = setTimeout(() => {
            this.playAudioFlag = false;
          }, 2000);
        },
      });
      // 设置播放音量大小
      this.player.volume(10);
    },
    countDown() {
      let THIS = this;
      THIS.goIndexTime--;
    },
    // 接收PCM流数据，并播放
    receivePCMStream(audio) {
      if (this.player === undefined || this.player === null) {
        //console.log('receivePCMStream 音频未初始化')
        return;
      }
      this.playAudioFlag = true;
      // 移除Base64字符串中的填充字符（如果有的话）
      audio = audio.replace(/=+$/, "");
      // 将Base64字符串解码为原始的二进制字符串
      var rawString = atob(audio);
      // 计算原始二进制数据的长度（每个字符代表一个字节）
      var rawLength = rawString.length;
      // 创建一个ArrayBuffer来存储解码后的二进制数据
      var buffer = new ArrayBuffer(rawLength);
      // 创建一个指向ArrayBuffer的Uint8Array视图
      var arraybuffer2 = new Uint8Array(buffer);
      // 将每个字符的ASCII值复制到Uint8Array视图中
      for (var i = 0; i < rawLength; i++) {
        arraybuffer2[i] = rawString.charCodeAt(i);
      }
      // 现在uint8Array包含了解码后的二进制数据
      this.player.feed(arraybuffer2.buffer);
    },
    // 续播音频
    playAudio() {
      if (this.player !== undefined && this.player !== null) {
        this.player.continue();
      }
    },
    // 暂停音频
    pauseAudio() {
      if (this.player !== undefined && this.player !== null) {
        this.player.pause();
      }
    },
    // 停止语音播放
    stopAudioPlay() {
      this.closeWs();
      this.playAudioEndIndex = 0;
      this.playAudioFlag = false;
      if (this.player != null) {
        this.player.destroy();
        this.player = null;
      }
    },
    // 语音播报
    // 初始化文字转语音WebSocket
    initWebSocket() {
      // 判断当前浏览器是否支持WebSocket
      if ("WebSocket" in window) {
        try {
          if (this.enableTts) {
            if (this.ttsWebsocket && this.ttsWebsocket.readyState === 1) {
              this.ttsWebsocket.close();
            }
            this.ttsWebsocket = new WebSocket(this.ttsWsUrl + this.getUserId());
            this.ttsWebsocket.onmessage = this.ttsWsOnMessage;
            this.ttsWebsocket.onopen = this.ttsWsOnOpen;
            this.ttsWebsocket.onerror = this.ttsWsOnError;
            this.ttsWebsocket.onclose = this.ttsWsOnClose;
          } else {
            console.log("没有启用文字转语音");
          }
        } catch (err) {
          this.$message.error("初始化文字转语音WebSocket异常！");
          this.ttsWsReconnect();
        }
      } else {
        this.$message.error("当前浏览器不支持WebSocket！");
      }
    },
    // ws接收到服务端发送的消息
    ttsWsOnMessage(event) {
      if (event.data === "HeartBeat") {
        //console.log('ttsWsOnMessage WebSocket: 心跳检测响应')
        this.ttsWsStartHeart();
        return;
      }
      let dataJson = JSON.parse(event.data);
      // console.log("----:",dataJson)
      if (
        dataJson.session !== undefined &&
        dataJson.session !== null &&
        dataJson.session !== ""
      ) {
        this.ttsSession = JSON.parse(event.data).session;
      }
      if (dataJson.status === 1 && dataJson.audio !== "") {
        this.receivePCMStream(dataJson.audio);
      }
    },
    // 打开ws连接时触发的事件
    ttsWsOnOpen() {
      this.ttsWsStartHeart();
    },
    // 发生错误时触发的事件
    ttsWsOnError() {
      this.ttsWsReconnect();
    },
    // 连接关闭时触发的事件
    ttsWsOnClose() {
      this.ttsWsCleanHeart();
      if (!this.ttsRealClose) {
        this.ttsWsReconnect();
      }
    },
    // ws发送消息给后端
    wsSendMessage(content) {
      console.log("tts wsSendMessage");

      let params = {
        text: content,
        spk_id: 0,
      };
      if (this.ttsWebsocket && this.ttsWebsocket.readyState === 1) {
        //console.log('tts readyState sendMessage');
        this.ttsWebsocket.send(JSON.stringify(params));
      } else {
        setTimeout(() => {
          //console.log('tts 1s 后发送')
          this.wsSendMessage(content);
        }, 1000);
      }
    },
    // 关闭语音合成ws
    closeWs() {
      if (
        this.ttsSession !== undefined &&
        this.ttsSession !== null &&
        this.ttsSession !== ""
      ) {
        let params = {
          task: "tts",
          signal: "end",
          session: this.ttsSession,
        };
        console.log("关闭ws: ", params);
        this.ttsWebsocket.send(JSON.stringify(params));
        this.ttsSession = "";
      }
      this.ttsWsCleanHeart();
      this.ttsRealClose = true;
      if (this.ttsWebsocket && this.ttsWebsocket.readyState === 1) {
        this.ttsWebsocket.close();
      }
      if (this.player !== undefined && this.player !== null) {
        this.player.destroy();
        this.player = null;
      }
    },
    // 语音合成重连
    ttsWsReconnect() {
      const that = this;
      if (that.ttsWsReconnectLock) {
        return;
      }
      that.ttsWsReconnectLock = true;
      that.ttsWsReconnectTimer && clearTimeout(that.ttsWsReconnectTimer);
      that.ttsWsReconnectTimer = setTimeout(() => {
        //console.log("ttsWsReconnect WebSocket: 重连中...");
        that.ttsWsReconnectLock = false;
        // websocket启动
        that.initWebSocket();
      }, 4000);
    },
    // 语音合成清除心跳检测机制
    ttsWsCleanHeart() {
      const that = this;
      clearTimeout(that.ttsWsTimeoutObj);
      clearTimeout(that.ttsWsServerTimeoutObj);
    },
    // 语音合成心跳检测启动
    ttsWsStartHeart() {
      const that = this;
      clearTimeout(that.ttsWsTimeoutObj);
      clearTimeout(that.ttsWsServerTimeoutObj);

      that.ttsWsTimeoutObj && clearTimeout(that.ttsWsTimeoutObj);
      that.ttsWsServerTimeoutObj && clearTimeout(that.ttsWsServerTimeoutObj);

      that.ttsWsTimeoutObj = setTimeout(() => {
        // 这里向后端发送一个心跳检测，后端收到后，会返回一个心跳回复
        that.ttsWebsocket.send("HeartBeat");
        //console.log("ttsWsStartHeart WebSocket: 发送心跳检测");

        that.ttsWsServerTimeoutObj = setTimeout(() => {
          // 如果超过一定时间还没重置计时器，说明websocket与后端断开了
          that.ttsWebsocket.close();
          //console.log("ttsWsStartHeart WebSocket: 未收到心跳检测回复");
        }, that.ttsHeartTimerTimeout);
      }, that.ttsHeartTimerTimeout);
    },

    onShowQrCode(message) {
      let text = message.eaUrl[0];
      QRCode.toDataURL(text, { width: 192, margin: 1 }).then((res) => {
        this.qrcode = res;
        this.qrCodeDialogVisible = true;
      });
    },
    handleLike(content, messageid) {
      this.isLiked = !this.isLiked;
      document
        .getElementById("like" + messageid)
        .setAttribute(
          "src",
          this.isLiked
            ? this.likedImage
            : require("@/assets/img/thumb-up-line.svg")
        );
      if (this.isLiked) {
        this.disisLiked = false;
        document
          .getElementById(messageid)
          .setAttribute("src", require("@/assets/img/thumb-down-line.svg"));
        chatApi.feedBackMessage(this.feedbackid, "like", content, this.getUserId());
      }
    },
    handleDislike(content, messageid) {
      this.disisLiked = !this.disisLiked;
      document
        .getElementById(messageid)
        .setAttribute(
          "src",
          this.disisLiked
            ? this.dislikedImage
            : require("@/assets/img/thumb-down-line.svg")
        );
      // this.dislikeImage = this.disisLiked? this.dislikedImage : require('@/assets/img/thumb-down-line.svg');
      if (this.disisLiked) {
        this.isLiked = false;
        // this.likeImage = require('@/assets/img/thumb-up-line.svg');
        document
          .getElementById("like" + messageid)
          .setAttribute("src", require("@/assets/img/thumb-up-line.svg"));
        chatApi.feedBackMessage(
          this.feedbackid,
          "dislike",
          content,
          this.getUserId()
        );
      }
    },
    handleCopy(content) {
      var _this = this;
      try {
        navigator.clipboard.writeText(content);
        _this.$message.success("文本复制成功");
      } catch (error) {
        console.error("文本复制失败:", error);
      }
    },
    onStopChatMessage() {
      var _this = this;
      let params = {
        user: this.getUserId(),
      };
      chatApi
        .stopChat(this.currentAnswer.message.taskId, params)
        .then((ret) => {
          if (ret.result === "success") {
            const message = this.messageList[this.currentAnswer.index];
            message.status = ChatStatus.Stop;
            if (!message.content) {
              message.content = "回答已停止";
            }
            this.updateMessageInConversation(message);
            _this.$message.success("停止回答成功");
            this.guideimg = require("@/assets/img/robot-blink.png");
          }
        })
        .catch((error) => {
          console.error(error);
          this.$message.error("停止回答失败");
        });
    },
    onGetMoreInfo() {
      this.submitInput("相关推荐", false);
    },
    handleChoiceItem(row) {
      this.submitInput(row, false);
    },
    onHotClick(item) {
      this.stopAudioPlay();
      this.closeWs();
      this.submitInput(item.text);
    },
    resetTempInputs(tempInputs) {
      if (!tempInputs) {
        this.tempInputs = {
          project_code: this.projectCode
        };
      } else {
        this.tempInputs = tempInputs;
      }
    },
    onOpenNewSession() {
      this.stopAudioPlay();
      this.closeWs();
      this.drawer = false
      if (!this.currentSessionId) {
        return;
      }
      this.currentSessionId = "";
      this.conversationId = "";
      this.messageList = [];
      this.sendWelcomeText();
      this.resetTempInputs();

    },
    onDelSessionItem(sessionId) {
      console.log(sessionId);
      let index = _.findIndex(this.sessionHistory, ["id", sessionId]);
      this.sessionHistory.splice(index, 1);
      localStorage.setItem(
        "SessionHistory",
        JSON.stringify(this.sessionHistory)
      );
      this.onOpenNewSession();
    },
    onHistoryClick(item) {
      // 展示会话
      console.log(item);
      if (this.currentSessionId === item.id) {
        return;
      }
      // 回显之前会话内容
      this.currentSessionId = item.id;
      this.messageList = [].concat(item.chatMessages);
      this.resetTempInputs(item.chatTempInputs);
      this.scrollToBottom(item.chatMessages[item.chatMessages.length - 1]);
    },
    onClearClick() {
      this.sessionHistory = [];
      localStorage.removeItem("SessionHistory");
      this.onOpenNewSession();
    },
    getUUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    // 生成消息
    messageCreator(
      type,
      content = "",
      title,
      status = ChatStatus.Pending,
      reasoningModel = false
    ) {
      return {
        id: this.getUUID(),
        time: new Date().getTime(),
        title: title,
        type: type,
        enableDelay: this.enableMessageStreamDelay ? (status === ChatStatus.Pending) : false,
        content: `${content}`,
        contentFinished: (status === ChatStatus.Finished),
        think: "",
        thinkFinished: !reasoningModel,
        inThink: false,
        reasoningModel: reasoningModel,
        status: status,
        taskId: "",
      };
    },
    addMessage2Conversation(message) {
      this.messageList.push(message);
      this.inputMessage = "";
      this.scrollToBottom(message);
    },
    scrollToBottom(message) {
      console.log(message);
      this.scrollListener.checkUserScroll((isUserScrolling) => {
        console.log("用户滚动" + isUserScrolling);
        this.hasUserScrollInAnswering = isUserScrolling;
        if (isUserScrolling) {
          clearTimeout(this.answerAutoScrollTimer);
        }
      });

      if (!this.hasUserScrollInAnswering) {
        this.answerAutoScrollTimer = setTimeout(() => {
          let messageDom = document.querySelector(`#m-${message.id}`);
          messageDom.scrollIntoView({ behavior: "smooth", block: "end" });
        }, 10);
      }
    },
    updateMessageInConversation(message) {
      const index = _.findIndex(this.messageList, ["id", message.id]);
      this.messageList[index].content = message.content;
      this.messageList[index].title = message.title;

      for (var key in message) {
        if (["title", "content"].indexOf(key) === -1) {
          this.$set(this.messageList[index], key, message[key]);
        }
      }
      this.updateSearchHistory(message);
      this.scrollToBottom(message);
    },
    ragbuttonHandle(message) {
      this.submitInput(message);
    },
    buttonHandle(content, message) {
      console.log(content);
      content = this.getTextAfterSecondThinkTag(content);
      console.log(content);
      var arr = "";
      var message1 = message + "**";
      const startIndex = content.indexOf(message1);
      if (startIndex === -1) {
        arr = "";
      }
      // 从 message 首次出现的位置之后开始查找 **
      const endIndex = content.indexOf("**", startIndex + message1.length);
      if (endIndex === -1) {
        arr = "";
      } else if (content.slice(startIndex, endIndex).length > 0) {
        arr = "**" + content.slice(startIndex, endIndex);
      }
      if (arr) {
        this.submitInputWithAnswer(message, arr);
      } else {
        this.submitInput(message);
      }
    },
    getTextAfterSecondThinkTag(text) {
      const lastIndex = text.lastIndexOf("</think>");
      if (lastIndex === -1) {
        // 如果没有找到 </think> 标签，返回原字符串
        return text;
      }
      // 截取最后一个 </think> 标签之后的数据
      return text.slice(lastIndex + 8);
    },
    // 输入框提交事件
    submitInputWithAnswer(message, answer) {
      if (!this.currentSessionId) {
        this.currentSessionId = this.getUUID();
        this.sessionHistory.push({
          id: this.currentSessionId,
          chatMessages: [].concat(this.messageList.concat()),
          chatTempInputs: this.tempInputs,
          timestamp: new Date().getTime(),
        });
      }

      this.inputMessage = message;
      this.questionMessage = this.inputMessage;

      // 添加问的内容
      let question = this.messageCreator(
        QUESTION,
        this.inputMessage,
        "",
        ChatStatus.Finished
      );
      this.addMessage2Conversation(question);
      this.addSearchHistory(question);

      // 添加回答等待效果
      let emptyAnswer = this.messageCreator(ANSWER);
      this.addMessage2Conversation(emptyAnswer);
      this.addSearchHistory(emptyAnswer);

      // 请求服务器
      const id = emptyAnswer.id;
      emptyAnswer.status = ChatStatus.Finished;
      emptyAnswer.content = answer;
      emptyAnswer.id = id;
      emptyAnswer.title = "为您找到这些";
      this.updateMessageInConversation(emptyAnswer);
      this.guideimg = require("@/assets/img/robot-happy.png");
    },
    submitInput(message) {
      this.hasUserScrollInAnswering = false;

      if (!this.currentSessionId) {
        this.currentSessionId = this.getUUID();
        this.sessionHistory.push({
          id: this.currentSessionId,
          chatMessages: [].concat(this.messageList.concat()),
          chatTempInputs: this.tempInputs,
          timestamp: new Date().getTime(),
        });
      }

      this.inputMessage = message;
      this.questionMessage = this.inputMessage;

      // 添加问的内容
      let question = this.messageCreator(
        QUESTION,
        this.inputMessage,
        "",
        ChatStatus.Finished
      );
      this.addMessage2Conversation(question);
      this.addSearchHistory(question);

      // 添加回答等待效果
      // 判断是否是思考模型
      let emptyAnswer;
      if (this.reasoningModel) {
        emptyAnswer = this.messageCreator(
          ANSWER,
          "",
          "",
          ChatStatus.Pending,
          true
        );
      } else {
        emptyAnswer = this.messageCreator(ANSWER);
      }
      this.addMessage2Conversation(emptyAnswer);
      this.addSearchHistory(emptyAnswer);

      // 请求服务器
      this.searchAnswer(emptyAnswer);
    },

    addSearchHistory(message) {
      const index = _.findIndex(this.sessionHistory, [
        "id",
        this.currentSessionId,
      ]);
      const searchHistory = this.sessionHistory[index].chatMessages;
      searchHistory.push(message);
      localStorage.setItem(
        "SessionHistory",
        JSON.stringify(this.sessionHistory)
      );
    },
    updateSearchHistory(message) {
      const sessionIndex = _.findIndex(this.sessionHistory, [
        "id",
        this.currentSessionId,
      ]);
      this.sessionHistory[sessionIndex].chatTempInputs = this.tempInputs;
      const searchHistory = this.sessionHistory[sessionIndex].chatMessages;
      const messageIndex = _.findIndex(searchHistory, ["id", message.id]);
      searchHistory[messageIndex] = message;
      localStorage.setItem(
        "SessionHistory",
        JSON.stringify(this.sessionHistory)
      );
    },
    removeConversationMessById(id) {
      // 根据id移除会话
      _.remove(this.messageList, ["id", id]);
    },
    searchAnswer(message) {
      this.stopAudioPlay();
      this.closeWs();
      this.initWebSocket();
      this.initPCMPlayer();
      var that = this;
      that.ttsText = "";
      var abortController = new AbortController();
      message.status = ChatStatus.Pending;
      const id = message.id;
      this.tempInputs.applyFrom = "1";

      chatApi.startChat({
        body: JSON.stringify({
          inputs: {
            ...this.tempInputs,
            project_code: this.projectCode
          },
          query: this.questionMessage,
          response_mode: "streaming",
          conversation_id: this.conversationId,
          user: this.getUserId(),
        }),
        openWhenHidden: true, // 页面文档被隐藏时会关闭sse链接并在显示时重连 true无论隐藏与否都不关闭
        signal: abortController.signal, // AbortSignal
        onmessage: async (ev) => {
          // 接收到消息之后填充消息数据
          const data = JSON.parse(ev.data);

          const event = data.event;
          if (event === "workflow_started") {
            message.id = id;
            message.taskId = data.task_id;
            message.status = ChatStatus.Answering;
            this.guideimg = require("@/assets/img/robot-think.png");
            this.updateMessageInConversation(message);
          } else if (event === "message") {
            if (message.status === ChatStatus.Stop) return;
            if (message.reasoningModel) {

                if(!message.inThink) {
                  message.content += data.answer;
                }else{
                  message.think += data.answer;
                }

                if(/<think>/.test(message.content)) {
                  message.inThink = true
                  if(message.content) {
                    message.think = message.content + "";
                    message.content = '';
                  }else{
                    message.think += data.answer;
                  }
                }

                if (message.think.indexOf("</think>") > -1) {
                  let arr = message.think.split("</think>");
                  message.think = arr[0];
                  message.inThink = false;
                  message.thinkFinished = true;
                  message.content += arr[1];
                  that.ttsText += arr[1];
                }

            } else {
              message.content += data.answer;
              that.ttsText += data.answer;
            }
            if (that.ttsText.length > 20) {
              this.wsSendMessage(that.ttsText);
              that.ttsText = "";
            }

            message.id = id;
            // message.title = "";
            message.taskId = data.task_id;
            this.feedbackid = data.message_id;
            message.status = ChatStatus.Answering;
            this.updateMessageInConversation(message);
          } else if (event === "node_finished") {
            const result = data.data;
            if (result.status !== "succeeded") {
              console.error("node_finished出错了：");
              console.error(result.error);
              return;
            }

            const outputs = result.outputs;
            if (!outputs || !outputs.answer_type) {
              // 未结束，不做处理
              return;
            }

            // 完成后处理
            message.title = "";
            message.id = id;
            message.answerType = outputs.answer_type || ""
            message.taskId = data.task_id;

            switch (outputs.answer_type) {
              case 'bsfw': // 办事服务
                message.title = "为您找到这些，请问您是要办理如下哪个事项呢？";
                message.itemList = (outputs.item_name_list || []).map(itemName => {
                  return {
                    itemName: itemName
                  }
                })
                message.policyList = outputs.policy_list || []
                message.pagedItemList = message.itemList.slice(0, 4)
                this.itemPage = {
                    ...this.itemPage,
                  total: message.itemList.length,
                  show: this.itemPage.currentPage + '/' +  Math.ceil(message.itemList.length / this.itemPage.pageSize)
                }
                message.pagedPolicyList = message.policyList.slice(0, 4)
                this.policyPage = {
                  ...this.policyPage,
                  total: message.policyList.length,
                  show: this.policyPage.currentPage + '/' +  Math.ceil(message.policyList.length / this.policyPage.pageSize)
                }
                break;
              case 'bszn': // 办事指南
                message.title = "已为您找到事项的办理指南";
                message.itemInfo = {
                  id: outputs.item_info.id,
                  item_name: outputs.item_info.item_name,
                  ...outputs.item_info.info
                }
                this.chatActiveName2 = 'first'
                break;
              case 'text': // 文本回复
                message.title = "";
                break;
            }

            this.updateMessageInConversation(message);
          } else if (event === "error") {
            // 提示错误信息
            console.log(data.message);
            message.title = "请求失败";
            message.status = ChatStatus.Fail;
            message.content = "请求失败，请重试";
            this.updateMessageInConversation(message);
            this.guideimg = require("@/assets/img/robot-sad.png");
          } else if (event === "message_end") {
            // 消息结束事件，收到此事件则代表流式返回结束
            if (message.status === ChatStatus.Answering) {
              message.status = ChatStatus.Finished;
            }
            if (that.ttsText.length > 0) {
              this.wsSendMessage(that.ttsText);
              that.ttsText = "";
            }
            if (this.useConversationId) {
              // 启用对话Id
              this.conversationId = data.conversation_id;
            }
          }
        },
        onopen: (res) => {
          // 打开
          if (res.status !== 200) {
            console.error("chatMessage失败：", res);
            message.title = "请求失败";
            message.status = ChatStatus.Fail;
            message.content = "很抱歉，服务器开小差了，请您稍后再试";
            this.guideimg = require("@/assets/img/robot-sad.png");
            this.updateMessageInConversation(message);
          }
        },
        onclose: () => {
          // 连接关闭
          setTimeout(() => {
            this.guideimg = require("@/assets/img/robot-magic.png");
          }, 4000); // 2000 毫秒即 2 秒
          console.log("连接关闭");
        },
        onerror: (err) => {
          // 失败
          abortController.abort();
          console.error("chatMessage失败：", err);
          message.title = "请求失败";
          message.status = ChatStatus.Fail;
          message.content = "很抱歉，服务器开小差了，请您稍后再试";
          this.guideimg = require("@/assets/img/robot-sad.png");
          this.updateMessageInConversation(message);
        },
      });

      /* this.updateMessageInConversation(emptyMessage.id, res, '为您找到这些');

            this.updateMessageInConversation(
              emptyMessage.id,
              `<p>${err}</p>
              <p>[自动回复] 当前系统繁忙，请稍后...</p>
              <p class="link">
                <a href="http://www.baidu.com" target="_blank">去网上看看</a>
              </p>`,
              '出问题了。。。'
            );*/
    },
    sendWelcomeText() {
      this.addMessage2Conversation(
        this.messageCreator(
          WELCOME,
          this.WelcomeText,
          this.WelcomeTitle,
          ChatStatus.Finished
        )
      );
    },
    handleWindowResize() {
      this.drawer = false
    },
    handleResize() {
      // 更新 windowWidth 为当前窗口宽度
      this.windowWidth = window.innerWidth;
    },
    changeLanguage(commond){
      this.changeAppLanguage(commond)
    },
    changeAppLanguage(language) {
      const that = this
      that.$store.dispatch('app/setLanguage', language)
      that.$i18n.locale = language
    },
  },
  mounted() {
    this.initSwiper()
    var sessionHistory = localStorage.getItem("SessionHistory");
    if (sessionHistory) {
      this.sessionHistory = JSON.parse(sessionHistory);
    }

    this.scrollListener = new ScrollListener(this.$refs.chatWrap);

    this.resetTempInputs()

    this.sendWelcomeText();

    window.addEventListener("resize", this.handleWindowResize)

    window.addEventListener('resize', this.handleResize);
    if(this.windowWidth > 768){
      this.webEquipmentType = true
    }else{
      this.webEquipmentType = false
    }
    this.changePageClass()

    // 隐藏推荐主题时放大聊天区域高度
    if (!this.openSuggestTheme && this.webEquipmentType) {
      const el = this.$refs.chatWrapper;
      const currentHeight = el.clientHeight;
      el.style.height = `${currentHeight + 40}px`;
    }
  },
  beforeDestroy() {
    // 销毁时移除事件监听器
    window.removeEventListener('resize', this.handleResize);
  },
  watch:{
    // 实时判断端类型
    windowWidth(newVal){
      if(newVal > 768){
        console.log('web');
        this.webEquipmentType = true
      }else{
        console.log('mobile');
        this.webEquipmentType = false
      }
    },
    currentThemeStyle (newValue) {
      this.$store.commit('style/updateTheme', newValue)
    },
  },
};
</script>

<style>
blockquote {
  color: #8b8b8b;
  white-space: pre-wrap;
  margin: 0;
  padding: 0 0 0 13px;
  line-height: 26px;
  position: relative;
}
</style>

<style lang="scss" scoped>
@import "../util/swiper/swiper-bundle.min.css";
@import "~@/assets/css/_var.scss";
@import "~@/assets/css/_handleTheme.scss";
.lightTheme{
  // $themeName:light;
  // theme(light, colorPrimary)
}

.buttonContainer {
  display: flex;
  flex-wrap: wrap;
  gap: 10px; /* 按钮间距 */
  margin-top: 16px;
  ::v-deep {
    .el-button {
      flex: 0 0 calc(25% - 10px);
      box-sizing: border-box; /* 防止边框影响布局 */ /* 可选样式 */
      padding: 10px;
      margin: 0; /* 清除默认 margin */
      text-align: center;
      white-space: nowrap; /* 防止文字换行 */
    }
  }
}
.page {
  width: 100%;
  .layout {
    margin: 0 auto;
    width: 100%;
  }
  .qrcode-img {
    display: block;
    margin: 0 auto;
  }
  .main {
    display: flex;
    height: calc(100vh);
    min-height: 530px;
    width: 100%;
    position: relative;
    border-radius: 14px;
  }
  .mobile-header {
    display: none;
  }

  .aside {
    padding-top: 28px;
    width: $sideWidth;
    height: calc(100%);
    background: rgba(246, 249, 254, 1);
    position: relative;
    .title{
      height: 120px;
      padding-top: 12px;
      width: 100%;
      text-align: center;
      font-family: PingFang SC;
      font-weight: 600;
      font-size: 20px;
      line-height: 100%;
      color: #424242;
      img{
        margin-bottom: 16px;
        width: 70px;
      }
    }
    .fengexian{
      width: 291px;
      opacity: 0.6;
      border: 1px solid;
      border-image: linear-gradient(90deg, rgba(0, 165, 255, 0) 0%, #00A5FF 50.48%, rgba(0, 165, 255, 0) 100%) 1;
      margin: 16px 0 10px 0;
    }
    .user-center{
      display: flex;
      align-items: center;
      gap: 8px;
      padding-left: 10px;
      margin-top: 16px;
      margin-left: 5px;
    }
  }

  .chat {
    width: 100%;
    font-size: var(--font-size);
    background: url("~@img/chat-bg.png") no-repeat bottom right;
    background: linear-gradient(to bottom, #ecf0ffcc, #ffffffcf);
    background-size: 100% 100%;
    // background-position: 100% 100%;
    padding: 10px 0;

    .input-wrap {
      margin: 0 #{$inputMargin};
      position: relative;
      z-index: 99;
      //width: calc(100% - 360px);
      .word-list{
        display: flex;
        margin-bottom: 10px;
        gap: 5px;
        overflow: hidden;
        position: relative;
        .name{
          width: 90px;
          flex-shrink: 0;
        }
      }
      .swiper-container {
        width: calc(100vw - #{$sideWidth} - 2 * #{$inputMargin} - 86px);
        height: 30px;  /* 轮播容器高度 */
        padding: 0 0px;
        margin: 0 16px;
        position: relative;
        font-size: 14px;
        .swiper-wrapper{
          width: 100% !important;
          //padding: 0 12px;
        }
        .swiper-slide {
          display: flex;
          align-items: center;  /* 垂直居中 */
          justify-content: center;  /* 水平居中 */
          color: #333;
          font-weight: 400;
          background: #FFFFFFB2;
          line-height: 1;
          white-space: nowrap;
          padding: 4px 8px;
          flex-shrink: 0;
          &:hover{
            border: 0.5px solid #3DD6F8B2;
            background: #005FB26B;
            cursor: pointer;
          }
        }
      }
      .swiper-button-next,
      .swiper-button-prev {
        top: 10%;  /* 控制垂直位置 */
        margin-top: 0px; /* 向上偏移半个高度 */
        width: 20px !important;
        height:20px !important;
        &:after{
          font-size: 18px;
        }
      }
      .swiper-button-next{
        right: 0%;
      }
      .swiper-button-prev {
        left: 80px;
      }
    }
    ::v-deep .the-input {
      width: 100%;
    }
  }
  .chat-top{
    display: flex;
    align-items: center;
    gap: 18px;
    height: 60px;
    margin-bottom: 20px;
    justify-content: end;
    padding-right: 40px;
    ::v-deep .el-switch{
      padding-top: 5px;
      .is-active{
        color: #303133;
      }
    }
  }
  .chat-wrapper {
    // height: $chatHeight;
    height: calc(100% - #{$inputHeight} - 140px);
    // width: $chatWidth;
    position: relative;
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    .stop-answer {
      text-align: center;
      z-index: 2;
      margin-top: 10px;
      .btn-stop-answer {
        border-radius: 10px;
      }
    }
  }

  .chat-wrap {
    // height: $chatHeight;
    // width: $chatWidth;
    overflow-y: auto;
    //padding: 0 20px;

    padding: 0 calc(#{$inputMargin} - 60px);

    .ai-tip {
      background-color: #fdf6ec;
      color: #e6a23c;
      display: inline-block;
      padding: 5px 20px;
      margin-top: 10px;
      border-radius: 4px;
    }

    .chat-item {
      width: 100%;
      
      & + .chat-item {
        margin-top: 14px;
      }

      .avatar {
        display: flex;
        align-items: start;
        user-select: none;
        gap: 10px;
        img {
          width: 50px;
        }
        .right-body{
          //max-width: calc(100% - 140px);
          width: calc(100% - 140px);
        }

        .talk {
          background: linear-gradient(180deg, #D4E8FF 0%, #FFFEF6 20.67%, #FFFFFFCC 50.48%);
          box-shadow: 0px 0px 14.8px 0px #38BAFF3B inset;
          backdrop-filter: blur(8.600000381469727px);
          border: 1px solid #FFFFFF;
          width: 100%;
          border-radius: 0 10px 10px 10px;
          padding: 10px 20px;
          box-shadow: 0 0 8px #e4e4e4;
          span{
            font-weight: bold;
            user-select: none;
            margin: 0 14px;
          }
        }
      }

      .message {
        padding: 0 14px;
        .text {
          margin-top: 10px;
          border-radius: 10px;
          //position: relative;

          .wrap {
            height: 100%;
            width: 100%;
            line-height: 2;
            .finished-tool {
              text-align: right;
              margin-top: 10px;
            }

            .related-matters {
              text-align: left;
              margin-top: 10px;
              position: relative;
              ::v-deep .el-popover {
                top: auto !important;
                bottom: 30px !important;
              }
            }
            .more-history{
              color: #4550b9;
              display: flex;
              align-items: center;
              font-family: PingFang SC;
              font-weight: 400;
              font-size: 14px;
              line-height: 100%;
              letter-spacing: 0%;
              margin-top: 10px;
              img{
                width: 20px;
                height: 16px;
              }
            }
            .chat-tip{
              width: 100%;
              .tuijian-list{
                width: 100%;
                .list-top{
                  width: 100%;
                  display:flex;
                  justify-content: space-between;
                  span{
                    margin: 0;
                    font-weight: 400;
                  }
                }
                .lists{
                  display: flex;
                  align-items: center;
                  //gap: 16px;
                  flex-wrap: wrap;
                  justify-content: space-between;
                  .list-item{
                    width: 33%;
                    flex-shrink: 0; /* 阻止缩小 */
                    height: 160px;
                    gap: 16px;
                    padding: 16px;
                    background: #FAFAFB;
                    // border-top: 1px solid #8C7DFF;
                    .name{
                      display: flex;
                      align-items: center;
                      gap: 6px;
                      img{
                        width: 24px;
                        height: 24px;
                      }
                    }
                    
                    ul {
                      list-style-type: disc !important; /* 设置无序列表的点符号为圆点 */
                      padding-left: 16px;
                      margin-top: 5px;
                    }

                    li {
                      padding:0 8px 0 4px;
                      .text{
                        margin: 0 !important;
                        white-space: nowrap; /* 防止文本换行 */
                        overflow: hidden; /* 隐藏超出的文本 */
                        text-overflow: ellipsis; /* 超出文本用省略号表示 */
                      }
                    }

                    li:hover {
                      color: #427AF4; /* 鼠标悬浮时字体变蓝 */
                    }
                  }
                }
              }
            }
            .tab-table{
              padding-top: 10px;
              ::v-deep .el-tabs{
                border-top-left-radius: 4px;
                border-top-right-radius: 4px;
                .el-tabs__nav-scroll{
                  background-color: #fff;
                  border-bottom: 1px solid #E6E9EF;
                  border-top-left-radius: 4px;
                  border-top-right-radius: 4px;
                }
                .el-tabs__nav{
                  border: none;
                }
                .el-tabs__item{
                  border: none;
                  &.is-active{
                    background: #0088FF;
                    color: #fff;
                  }
                }
              }
              .lists{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                gap: 1%;
                .list-item{
                  cursor: pointer;
                  display: flex;
                  width: 24%;
                  height: 72px;
                  align-items: center;
                  justify-content: flex-start;
                  padding: 12px;
                  border-radius: 4px;
                  background: #FFFFFF;
                  line-height: 18px;
                  gap: 4px;
                  .text{
                    margin-left: 4px;
                    margin-top: 0;
                    display: -webkit-box;
                    -webkit-line-clamp: 3; /* 限制显示行数为3 */
                    -webkit-box-orient: vertical;
                    overflow: hidden; /* 隐藏超出部分 */
                    text-overflow: ellipsis; /* 省略号 */
                  }
                  &:hover{
                    background: #E8F2FF;
                    border: 1px solid #BFDAFF;
                  }
                }
              }
              .lists-zhengce{
                display: flex;
                justify-content: space-between;
                // align-items: start;
                align-items: stretch;  /* 保证子元素高度相同 */
                gap: 1%;
                .list-item{
                  display: flex;
                  flex-direction: column;
                  width: 19%;
                  align-items: center;
                  padding: 12px;
                  border-radius: 4px;
                  background: #FFFFFF;
                  line-height: 18px;
                  gap: 4px;
                  .title{
                    font-family: PingFang SC;
                    font-weight: 600;
                    text-align: justify;
                  }
                  .text{
                    font-family: PingFang SC;
                    font-weight: 400;
                    margin-top: 0;
                    text-align: justify;
                  }
                  img{
                    width: 100%;
                  }
                  .from{
                    width: 100%;
                    display: flex;
                    justify-content: start;
                    margin-top: 8px;
                    img{
                      width: 16px;
                      height: 16px;
                    }
                    .from-name{
                      flex:1;
                      white-space: nowrap;
                      overflow: hidden; /* 隐藏超出部分 */
                      text-overflow: ellipsis; /* 省略号 */
                    }
                  }
                  &:hover{
                    background: #E8F2FF;
                    border: 1px solid #BFDAFF;
                  }
                }
              }
              .pagination{
                width: 100%;
                text-align: center;
                margin-top: 10px;
                ::v-deep .el-pagination{
                  font-family: PingFang SC;
                  font-weight: 400;
                  line-height: 100%;
                  letter-spacing: 1%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  .btn-prev ,.btn-next{
                    width: 20px;
                    height: 20px;
                    min-width: 20px !important;
                    gap: 10px;
                    padding: 2px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .el-icon{
                      width: 12px !important;
                      min-width: 12px !important;
                    }
                  }
                }
              }
              
            }
            .info-table{
              padding-top: 10px;
              ::v-deep .el-tabs{
                border-top-left-radius: 4px;
                border-top-right-radius: 4px;
                .el-tabs__nav-scroll{
                  background-color: #fff;
                  border-bottom: 1px solid #E6E9EF;
                  border-top-left-radius: 4px;
                  border-top-right-radius: 4px;
                }
                .el-tabs__nav{
                  border: none;
                }
                .el-tabs__item{
                  border: none;
                  &.is-active{
                    background: #0088FF;
                    color: #fff;
                  }
                }
              }
            }
            .my-handle{
              width: 100%;
              border-top: 1px solid #3DD6F833;
              margin-top: 12px;
              font-weight: 400;
              .btn-handle{
                background: linear-gradient(270deg, #3146FF 0%, #00A5FF 100%);
                width: 96px;
                height: 34px;
                padding-top: 6px;
                padding-right: 16px;
                padding-bottom: 6px;
                padding-left: 16px;
                border-radius: 8px;
                color: #fff;
              }
            }
          }
        }
      }

      &.self {
        //padding: 0 14px;
        display: flex;
        justify-content: flex-end;

        .message {
          padding-right: 10px;
        }

        .text {
          background: linear-gradient(180deg, rgba(49, 70, 255, 0.7) 0%, rgba(0, 165, 255, 0.7) 100%);
          border-radius: 10px 0 10px 10px;
          padding: 18px 20px;
          box-shadow: 0 0 8px #e4e4e4;
          // max-width: calc(100% - 100px);
          span{
            font-weight: bold;
            user-select: none;
            margin: 0 14px;
          }
        
          .wrap {
            // background: linear-gradient(
            //   90deg,
            //   rgba(38, 111, 235, 1) 0%,
            //   rgba(66, 135, 255, 1) 100%
            // );
            color: #fff;
            font-size: 16px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    .layout {
      margin: 0 auto;
      width: 100%;
      background:
        url(../assets/img/mobile/topbg.png),
        url(../assets/img/mobile/buttombg.png),
        #F5F8FF;//标记
      background-repeat: no-repeat;
      background-position: center top ,center bottom,center center;
      background-size: 100% 338px ,100% 338px,100% 100%;
    }
    .main {
      height: calc(100vh - #{$mheaderHeight});
      min-height: auto;
    }
    .aside {
      display: none;
    }
    .mobile-header {
      display: block;
      padding: 20px 16px 0 !important;
      font-size: 22px;
      .icon-button {
        line-height: 2.3rem;
      }
      .mobile-title {
        font-weight: bold;
        color: #42444D;
        display: flex;
        justify-content: center;
        ::v-deep .el-tabs{
          margin-top: -4px;
          .el-tabs__header.is-clickable .el-tabs__item.is-active {
            box-shadow: none !important;
          }
          .el-tabs__nav-wrap::after {
            background-color: transparent;
          }
          .el-tabs__item.is-active{
            font-family: PingFang SC;
            font-weight: 600;
            font-size: 14px;
            text-align: center;
            color: #131316;
          }
        }
      }
      i {
        color: #42444D;
      }
    }
    .mobile-history{
      width: 100%;
      height: calc(100vh - #{$mheaderHeight});
    }

    .drawer-history {
      ::v-deep .list {
        height: calc(100vh - 100px);
      }
    }
    .chat {
      background: transparent !important;
      .chat-wrapper{
        margin: 0;
        height: calc(100% - #{$minputHeight});
        .chat-wrap{
          padding: 0 12px;
          .chat-item{
            .avatar{
              display: flex;
              flex-direction: column;
              .answer-logo{
                display: flex;
                align-items: center;
                gap: 10px;
                img{
                  width: 20px;
                  height: 27px;
                }
              }
              .right-body{
                width: 100%;
                min-width: 343px;
                .talk{
                  width: 100%;
                  .tuijian{
                    width: 100%;
                    padding: 0 0px;
                    .tuijian-header{
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                      .left{
                        width: 212px;
                        .left-line{
                          display: flex;
                          align-items: center;
                          gap: 8px;
                          font-family: PingFang SC;
                          font-weight: 600;
                          font-size: 20px;
                          line-height: 100%;
                          letter-spacing: 0%;
                          color: #131316;
                          img{
                            width: 26px;
                            height: 20px;
                          }
                        }
                        .left-intro{
                          margin-top: 10px;
                          font-family: PingFang SC;
                          font-weight: 400;
                          font-size: 14px;
                          line-height: 16px;
                          letter-spacing: 0%;
                          color: #868997;
                        }
                      }
                      img{
                        width: 106px;
                        height: 93px;
                      }
                    }
                    .tuijian-items{
                      width: 100%;
                      display: flex;
                      flex-direction: column;
                      margin-top: 10px;
                      gap: 6px;
                      .tuijian-item{
                        border-radius: 4px;
                        display: flex;
                        justify-content: space-between;
                        padding: 8px 12px;
                        background: #F8F8F9;
                        font-family: PingFang SC;
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 24px;
                        letter-spacing: 0%;
                        color: #131316;
                        i{
                          color: #9C9FAA;
                        }
                      }
                    }
                  }
                  &.whitebg{
                    background: #fff !important;
                  }
                }
                .talk-buttom{
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-top: 10px;
                  .left-button{
                    padding: 5px; /* 设置内边距 */
                    background-color: #fff;
                  }
                  .icon-buttons{
                    margin-top: 0 !important;
                    background-color: #fff;
                  }
                }
              }
            }
            .message{
              padding: 0;
              .text{
                .wrap{
                  .ec-message__text{
                    margin-top: 10px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    font-size: 12px !important;
                    line-height: 14px;
                    letter-spacing: 0%;
                    color: #6EA1FF !important;
                    span{
                      margin: 0 !important;
                    }
                  }
                  .total{
                    width: 100%;
                    border-radius: 4px;
                    padding: 8px;
                    gap: 12px;
                    border: 1px solid #BFDAFF;
                    .knows, .thinks{
                      font-family: PingFang SC;
                      font-weight: 400;
                      font-size: 14px;
                      line-height: 26px;
                      color: #868997;
                      span{
                        color: #6EA1FF;
                        margin:  0 ;
                        font-weight: 400;
                      }
                    }
                  }
                  .tab-table2{
                    padding-top: 10px;
                    ::v-deep .el-tabs{
                      border-top-left-radius: 4px;
                      border-top-right-radius: 4px;
                      .el-tabs__header{
                        margin-bottom: 0;
                      }
                      .el-tabs__nav-scroll{
                        background-color: #F5F6F9;
                        // border-bottom: 1px solid #E6E9EF;
                        border-top-left-radius: 4px;
                        border-top-right-radius: 4px;
                      }
                      .el-tabs__nav{
                        border: none;
                      }
                      .el-tabs__item{
                        border: none;
                        &.is-active{
                          background: transparent;
                          color: #427AF4;
                        }
                      }
                    }
                    .lists{
                      display: flex;
                      flex-direction: column;
                      justify-content: space-between;
                      align-items: center;
                      gap: 1%;
                      .list-item{
                        display: flex;
                        width: 100%;
                        align-items: center;
                        justify-content: space-between;
                        padding: 12px;
                        border-radius: 4px;
                        background: #FFFFFF;
                        line-height: 18px;
                        gap: 4px;
                        .left{
                          display: flex;
                          gap: 6px;
                          img{
                            width: 24px;
                            height: 24px;
                          }
                          .text{
                            flex:1;
                            margin: 0;
                            display: flex;
                            align-items: center;
                            overflow: hidden;
                            text-overflow: ellipsis; /* 省略号 */
                            font-size: 14px;
                            color: #42444D;
                          }
                        }

                        &:hover{
                          background: #E8F2FF;
                        }
                      }
                    }
                  }
                  .more-history{
                    ::v-deep .el-button{
                      background: #E8F2FF;
                      color: #427AF4;
                    }
                  }
                  .my-handle{
                    width: 100%;
                    color: #717484;
                    margin-top: 12px;
                    font-weight: 400;
                    .tuijian-list{
                      width: 100%;
                      .item{
                        font-size: 14px;
                        color: #427AF4;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      }
                    }
                  }
                }
              }
            }
            &.self{
              padding: 0;
              .text{
                background: #0080FF;
                padding: 10px 20px;
              }
            }
          }
        }
      }
      .input-wrap-mobile{
        padding: 0 10px;
        position: relative;
        z-index: 99;
        width: calc(100%);
        .word-list{
          margin-bottom: 10px;
          gap: 5px;
          overflow: auto;
          white-space: nowrap;
          position: relative;
          .list-item{
            display: inline-block;
            font-weight: 400;
            font-size: 14px;
            line-height: 100%;
            letter-spacing: 0%;
            color: #42444D;
            margin: 0 10px;
          }
          &::-webkit-scrollbar {
            display: none; /* 隐藏滚动条 */
          }
        }
      }
    }

    .buttonContainer {
      ::v-deep {
        .el-button {
          flex: auto;
          white-space: normal !important;
          line-height: 1.4;
          text-align: left;
        }
      }
    }

    .info-table {
      .materials {
        .material {
          .label {
            text-align: right;
            width: 34%;
            display: inline-block;
          }

          .value {
            width: 65%;
            display: inline-block;
          }
        }
      }
    }
  }
}
.icon-buttons {
  margin-top: 10px; /* 这里的 20px 可以根据需要调整为合适的间距值 */
  display: flex;
  gap: 10px;
  background: none;
  padding: 5px; /* 设置内边距 */
  display: inline-flex; /* 使用 inline-flex 使容器宽度自适应内容 */
  gap: 10px; /* 设置按钮之间的间距 */
  ::v-deep .el-button{
    background-color: transparent;
    font-size: 18px;
  }
  .ver-line{

  }
}
.logo {
  position: absolute;
  z-index: 80 !important;
  left: 0;
  top: 0;
  width: 200px;
  height: 200px;
  transform: translate(0, -80%);
}
</style>
